/**
 * visitorTracking.ts
 * 
 * Utility functions for tracking visitor activity including modal views
 */

import { API_CONFIG } from '../config/api.config';

const API_URL = API_CONFIG.getBackendOrigin();

/**
 * Track modal view
 * @param modalName - Name of the modal being opened
 */
export async function trackModalView(modalName: string): Promise<void> {
  try {
    const sessionID = getOrCreateSessionID();
    
    const trackingData = {
      pageURL: window.location.href,
      referrer: document.referrer,
      sessionID: sessionID,
      screenResolution: `${window.screen.width}x${window.screen.height}`,
      language: navigator.language,
      userAgent: navigator.userAgent,
      modalName: modalName
    };

    await fetch(`${API_URL}/api/visitor/track`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(trackingData),
    });
  } catch (error) {
    // Silent fail - don't interrupt user experience
    console.error('Failed to track modal view:', error);
  }
}

/**
 * Get or create session ID
 * @returns Session ID string
 */
function getOrCreateSessionID(): string {
  const STORAGE_KEY = 'rjbd_session_id';
  let sessionID = sessionStorage.getItem(STORAGE_KEY);
  
  if (!sessionID) {
    sessionID = `session_${Date.now()}_${Math.random().toString(36).substring(2, 11)}`;
    sessionStorage.setItem(STORAGE_KEY, sessionID);
  }
  
  return sessionID;
}
